import React from "react";
import "./Section.css";
import group1 from '../Images/mens25.jpg'
// import group2 from '../Images/img4.webp'
// import group3 from "../Images/img6.webp"

function Section() {
  return (
    <section className="featured-section py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Column - Images */}
          <div className="col-lg-8 col-12 image-col position-relative">
            <div className="main-image-wrapper">
              <img
                src={group1}
                alt="Main"
                className="main-image"
              />

              {/* <div className="top-slide">
                <img src={group2} alt="Top" />
              </div> */}

              {/* <div className="bottom-slide">
                <img src={group3} alt="Bottom" />
              </div> */}

              <button className="shop-now-btn">Shop Now</button>
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="col-lg-4 col-12 text-col mt-4 mt-lg-0" id="section-Card">
            <h2 className="text-white">Discover Our Collection</h2>
            <p className="text-white">
              Explore a curated range of premium African clothing and accessories. 
              Our designs are inspired by culture, crafted for style, and perfect for every occasion. 
              Shop now and elevate your wardrobe!

              Our goal with this collection was to create pieces could be inherited by generations to come. A key focus was on craftsmanship, using traditional techniques that have been preserved by African artisans.
              
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Section;
